import { useEffect } from "react";
import { useAuth } from "../auth-provider/auth-provider";

const AppLogout = ({ children }) => {
    const auth = useAuth();

    useEffect(() => {checkForTokenExpiration()})
    
    const checkForTokenExpiration = () => {
        if(auth?.user){
            const expiration = auth?.user?.expiresIn;
            const now_is = new Date().getTime() / 1000;
            if (now_is > expiration){
                auth.logout();
            }
        }
    }

    return children;
  };
  export default AppLogout;